import { render, staticRenderFns } from "./VModelNumber.vue?vue&type=template&id=15fb43b2"
import script from "./VModelNumber.vue?vue&type=script&lang=js"
export * from "./VModelNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports